<template>
  <card-wrapper title="Nie znaleziono strony..." class="card-wrapper">
    <div class="error-message is-unselectable">
      <img src="../assets/img/not-found.svg" />
      <p>Niestety, strona której szukasz nie istnieje.</p>
      <p>Prosimy sprawdzić, czy wpisany został prawidłowy adres w pasku adresowym Twojej przeglądarki.</p>      
      <router-link :to="{ name: 'home' }" class="button is-white is-large is-rounded is-outlined">
        <icon name="fa-home" />
        <span>Strona główna</span>
      </router-link>
    </div>
  </card-wrapper>
</template>

<script>
import { CardWrapper, Icon } from "%helpers";

export default {
  name: "messages",

  components: {
    CardWrapper,
    Icon
  }
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  min-height: 150vh;
  justify-content: flex-start;

  .message-placeholder {
    text-align: center;

    &__img {
      width: 50%;
    }
  }
}

.error-message {
  padding: 1rem;
  color: $white;
  font-size: 1.5rem;
  text-align: center;

  @include mobile {
    font-size: 1.2rem;

    img {
      width: 45%;
    }

    .button {
      font-size: 1.2rem;
    }
  }
  @include until($small-mobile) {
    img {
      width: 65%;
    }
  }
  @include tablet {
    img {
      width: 35%;
    }
  }

  @include desktop {
    img {
      width: 25%;
    }
  }
}

.button {
  margin-top: 2rem;
}
</style>
